import NiceModal from "@ebay/nice-modal-react";
import { storeRequester } from "App";
import ButtonEclipse from "components/buttons/ButtonEclipse";
import InputEmail from "components/inputs/InputEmail";
import InputPassword from "components/inputs/InputPassword";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import ModalBase from "modals/base/ModalBase";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getTokenPayload, validateInputs } from "shared/utils/Utils";
import style from "./MemberSignInModal.module.css";
import logoCircle from "resources/img/logoCircle.png";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { CButton } from "@coreui/react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo4 } from "resources/img/logo/03.svg";
import {
  emailFormat,
  mobileNoFormat,
  passwordFormat,
} from "InitialData/regExp";
import { ToastContainer, toast } from "react-toastify";
import WorldvapeLogo from "resources/img/logo/worldvape_logo.svg";
import Center from "layouts/wrapper/Center";
import useLocalStorage from "shared/hooks/useLocalStorage";
import { useSelector } from "react-redux";
import { Cookie, getCookie, setCookie } from "shared/StoreRequester";
import { AuthReducer } from "shared/redux/reducers/auth/AuthReducer";
import { RegionContext } from "providers/RegionProvider";
import P from "components/P";
import CheckCircle from "components/inputs/checkBox/CheckCircle";

const MemberSignInModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const [withHeader, withFooter] = [false, false];
  const [width, height] = ["min(100%, 500px)", "initial"];
  const withCloseButton = true;
  const modal = useRef();
  const clickOutsideToClose = true;
  const title = t("signIn");
  const buttonText = t("close");
  const inputsSignIn = useRef([]);
  const { regionId } = useContext(RegionContext);
  // const navigate = useNavigate();
  // const { isMobile } = useContext(BrowserDetectContext);
  const [hasCookie, setHasCookie] = useState(false);
  // const [currentCustomer, setCurrentCustomer] = useState(null);
  const dispatch = useDispatch();

  const onSignInClick = () => {
    signIn();
  };
  const onSignUpClick = () => {
    modal.current.close();
    NiceModal.show("memberSignTabModal");
  };

  const onKeyPress = (event) => {
    if (event.keyCode === 13) {
      signIn();
    }
  };
  const buttonStyle = {
    // width: "150px",
    "--cui-btn-line-height": "23px",
    "--cui-btn-color": "black",
    backgroundColor: "white",
    color: "var(--font-color)",
  };

  const signIn = async () => {
    let data = { email: "", password: "" };
    data.email = inputsSignIn.current[0].getValue();
    data.password = inputsSignIn.current[1].getValue();
    
    if (data.email === "" || data.password === "") {
      toast.warning(t("이메일과 비밀번호를 입력해주세요."), {
        autoClose: 2000,
        position: toast.POSITION.BOTTOM_CENTER
      });
      return;
    }
  
    await storeRequester.Login(
      { email: data.email, password: data.password },
      (response) => {
        // access_token이 있으면 로그인 성공
        if (response?.access_token) {
          dispatch(AuthReducer.actions.setToken(response.access_token));
          setHasCookie(true);
          storeRequester.getMyCart(regionId);
          storeRequester.getCurrentCustomer({}, (d) => {
            if (d.customer.resetPassword) {
              NiceModal.show("customerPasswordChange", { isForced: true });
            }
          });
          return;
        }
  
        // 에러 응답 처리
        if (response?.message === "account is locked") {
          toast.error(t("계정이 잠겨있습니다. 관리자에게 문의하세요."), {
            autoClose: 2000,
            position: toast.POSITION.BOTTOM_CENTER
          });
        } else if (response?.message === "email or password is not correct") {
          toast.error(t("로그인 정보가 올바르지 않습니다."), {
            autoClose: 2000,
            position: toast.POSITION.BOTTOM_CENTER
          });
        } else {
          console.error("Login error:", response);
          toast.error(t("로그인 중 오류가 발생했습니다. 다시 시도해주세요."), {
            autoClose: 2000,
            position: toast.POSITION.BOTTOM_CENTER
          });
        }
      }
    );
  };
  useEffect(() => {
    dispatch(AuthReducer.actions.reset())
  }, [])
  useEffect(() => {
    if (inputsSignIn.current[0]) {
      inputsSignIn.current[0].focus();
    }
  }, []);
  useEffect(() => {
    if (hasCookie) {
      const token = getCookie(Cookie.JWT);
      const { customer_id } = getTokenPayload(token);
      if (customer_id) {
        // to-do 카트 지우고, 로직 변경
        const cartId = getCookie(Cookie.Cart);
        if (cartId)
          storeRequester.updateCart(cartId, { customer_id: customer_id });
      }
      modal.current.close();
      if (props.reload === true) window.location.reload();
    }
  }, [hasCookie]);

  return (
    <ModalBase
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
      overflow={"visible"}
    >
      <div className={style.wrap}>
        <VerticalFlex gap={10}>
          <FlexChild height={70}>
            <Center width={"70%"}>
              <img src={WorldvapeLogo} width={"100%"} alt="logo" />
            </Center>

            {/* <Logo4 fill="#e94619" className={style.logoIcon} style={{ height: 80 }} /> */}
            {/* <img src={logoCircle} width={"90px"} /> */}
          </FlexChild>
          <FlexChild height={30}>
            <div className={style.dummy}></div>
          </FlexChild>
          <FlexChild alignItems={"flex-start"}>
            <InputEmail
              onKeyPress={onKeyPress}
              size={"lg"}
              signIn
              ref={(el) => (inputsSignIn.current[0] = el)}
              placeHolder={t("email")}
            />
          </FlexChild>
          <FlexChild>
            <VerticalFlex flexStart gap={5}>
              <FlexChild>
              <InputPassword
                onKeyPress={onKeyPress}
                size={"lg"}
                signIn
                ref={(el) => (inputsSignIn.current[1] = el)}
                placeHolder={t("password")}
                confirmVisible={false}
              />
              </FlexChild>
              <FlexChild>
                <P color={"var(--main-color)"}  size={9}>리뉴얼 후 초기 비밀번호는 1234입니다.</P>
                <P color={"red"} size={9}>로그인 후 비밀번호를 꼭 변경해주세요 / 변경을 해야만 이용이 가능합니다.</P>
              </FlexChild>
              <FlexChild>
                <CheckCircle label={"자동로그인"} checked />
              </FlexChild>
            </VerticalFlex>
          </FlexChild>
          <FlexChild height={150}>
            <div className={style.dummy}></div>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex justifyContent={"center"} gap={15}>
              <FlexChild height={40}>
                <ButtonEclipse
                  fontSize={"19px"}
                  backgroundColor={"var(--main-color)"}
                  text={t("signIn")}
                  onClick={onSignInClick}
                />
              </FlexChild>
              <FlexChild height={40}>
                <ButtonEclipse
                  fontSize={"19px"}
                  color={"black"}
                  border={"1px solid black"}
                  text={t("signUp")}
                  onClick={onSignUpClick}
                />
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
        </VerticalFlex>
      </div>
    </ModalBase>
  );
});

export default MemberSignInModal;
